<template>
    <div>
        <b-card no-body class="quote-details-card mt-1">
            <b-card-header>
                <b-row class="border-bottom-row mx-0 pb-4">
                    <b-col lg="6" md="5">
                        <img v-if="company_logo" :src="company_logo.path" width="95"/>
                        <img v-else src="@/assets/images/garden-help/Logo.png" width="95" />
                        <b-card-title class="card-title-page-garden-help-default my-1 d-inline ">
                          {{ isQuote === true ? 'Quote' : (isQuote === false ? 'Invoice' : 'Quote') }} Details
                        </b-card-title>
                    </b-col>
                    <b-col lg="6" md="7" class="d-flex align-items-center justify-content-end">
                        <b-row class="w-100 justify-content-end">
                            <b-col md="6" class="my-1">
                                <b-card-sub-title class=" card-subtitle-garden-help">
                                    <p class="form-label-garden-help  w-100 mb-0">Contractor Name </p> {{
                                        contractor_name
                                    }}
                                </b-card-sub-title></b-col>
                            <b-col md="6" class="my-1" v-if="vat_number">
                                <b-card-sub-title class=" card-subtitle-garden-help">
                                    <p class="form-label-garden-help  w-100 mb-0">VAT Number</p> {{ vat_number }}
                                </b-card-sub-title></b-col> 
                            <b-col md="6" class="my-1" v-if="company_reg_no">
                                <b-card-sub-title class=" card-subtitle-garden-help">
                                    <p class="form-label-garden-help  w-100 mb-0">Company Registration No.</p> {{ company_reg_no }}
                                </b-card-sub-title></b-col>

                            <b-col md="6" class="my-1" v-if="contractor_email">
                                <b-card-sub-title class=" card-subtitle-garden-help" style="text-transform: lowercase;">
                                    <p class="form-label-garden-help  w-100 mb-0">Contractor Email</p> {{
                                        contractor_email }}
                                </b-card-sub-title></b-col>
                            <b-col md="6" class="my-1" v-if="contractor_phone">
                                <b-card-sub-title class=" card-subtitle-garden-help">
                                    <p class="form-label-garden-help  w-100 mb-0">Contractor Phone </p> {{
                                        contractor_phone
                                    }}
                                </b-card-sub-title>
                            </b-col>
                            <b-col md="6" class="my-1" v-if="contractor_address">
                                <b-card-sub-title class=" card-subtitle-garden-help">
                                    <p class="form-label-garden-help  w-100 mb-0">Contractor Address </p> {{
                                    contractor_address
                                    }}
                                </b-card-sub-title>
                            </b-col>
                            <b-col md="6" class="my-1" v-if="contractor_reg_number">
                                <b-card-sub-title class=" card-subtitle-garden-help">
                                    <p class="form-label-garden-help  w-100 mb-0">Contractor Reg. Number </p> {{
                                    contractor_reg_number
                                    }}
                                </b-card-sub-title>
                            </b-col>

                        </b-row>

                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body class="px-2 pt-1">
                <b-row class="quote-details-row mx-0" cols-lg="6" cols-md="3" cols="2">
                    <b-col>
                        <b-form-group class="form-group-garden-help" label="Issue date" label-for="issue_date"
                            :issue_date="issue_date" label-class="form-label-garden-help">
                            <span class="form-control form-control-garden-help">
                                {{ issue_date }}
                            </span>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group class="form-group-garden-help" label="Booking date" label-for="booking_date"
                            :booking_date="booking_date" label-class="form-label-garden-help">
                            <span class="form-control form-control-garden-help">
                                {{ booking_date }}
                            </span>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group class="form-group-garden-help" label="Type of work" label-for="job_type"
                            :job_type="job_type" label-class="form-label-garden-help">
                            <span class="form-control form-control-garden-help">
                                {{ job_type }}
                            </span>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group class="form-group-garden-help" label="Quote no." label-for="quote_number"
                            :quote_number="quote_number" label-class="form-label-garden-help">
                            <span class="form-control form-control-garden-help">
                                {{ quote_number }}
                            </span>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group class="form-group-garden-help" label="Quote for" label-for="customer_name"
                            :customer_name="customer_name" label-class="form-label-garden-help">
                            <span class="form-control form-control-garden-help">
                                {{ customer_name }}
                            </span>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group class="form-group-garden-help" label="Status" label-for="quote_status"
                            :quote_status="quote_status" label-class="form-label-garden-help">
                            <span class="form-control form-control-garden-help quoteStatusSpan "
                                :class="quote_status + '_status'">
                                {{ quote_status }} {{ quote_paid ? 'Paid' : '' }}
                            </span>
                        </b-form-group>
                    </b-col>

                </b-row>

                <b-row class="quote-table-container">
                    <!-- <b-table stacked="sm" class="gardenHelpTable quoteTableGH" :items="quote_table_items"
                        :fields="quote_table_fields">
                        <template #cell(service)="data">
                            {{ data.value }}
                            <img src="@/assets/images/garden-help/info-icon.png" :id="'info_' + data.item.index" />
                            <b-popover custom-class="popover-garden-help" :target="'info_' + data.item.index"
                                triggers="hover" placement="right" :content="data.item.description">
                            </b-popover>
                        </template>
                        <template #custom-foot>
                            <b-tr class="subtotal-tr">
                                <b-th>Subtotal</b-th>
                                <b-th class="value-th">{{currency_icon}}{{ subtotal }}</b-th>
                            </b-tr>
                            <b-tr class="vat-tr">
                                <b-th>Vat</b-th>
                                <b-th class="value-th">{{currency_icon}}{{ vat }}</b-th>
                            </b-tr>
                            <b-tr class="total-tr">
                                <b-th></b-th>
                                <b-th>
                                    <p class="labelP">TOTAL AMOUNT</p>
                                    <p class="valueP">{{currency_icon}}{{ total }}</p>
                                    <p class="labelP">VAT Included</p>
                                </b-th>
                            </b-tr>
                        </template>
                    </b-table> -->
                    <b-table-simple class="gardenHelpTable quoteTableGH" responsive>
                        <b-thead>
                            <b-tr>
                                <b-th>Service/Item</b-th>
                                <b-th>Price</b-th>
                                <b-th>QTY</b-th>
                                <b-th>Total Price</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in quote_table_items" :key="index">
                                <b-td>{{ item.name }}
                                    <img v-if="item.description" src="@/assets/images/garden-help/info-icon.png"
                                        :id="'info_' + (index + 1)" class="info-icon" />
                                    <b-popover v-if="item.description" custom-class="popover-garden-help"
                                        :target="'info_' + (index + 1)" triggers="hover focus" placement="right"
                                        :content="item.description">
                                    </b-popover>
                                </b-td>
                                <b-td>{{ currency_icon }}{{ item.type == 'item' ? item.price_per_item : item.price }}</b-td>
                                <b-td> {{ item.type == 'item' ? item.quantity : '' }}</b-td>
                                <b-td>{{ currency_icon }}{{ item.price }}</b-td>
                            </b-tr>
                        </b-tbody>

                        <b-tfoot>
                            <b-tr class="subtotal-tr">
                                <b-th></b-th>
                                <b-th></b-th>
                                <b-th>Subtotal</b-th>
                                <b-th class="value-th">{{ currency_icon }}{{ subtotal }}</b-th>
                            </b-tr>
                            <b-tr class="vat-tr" v-if="vat != 0">
                                <b-th></b-th>
                                <b-th></b-th>
                                <b-th>Vat</b-th>
                                <b-th class="value-th">{{ currency_icon }}{{ vat }}</b-th>
                            </b-tr>
                            <b-tr class="total-tr">
                                <b-th></b-th>
                                <b-th></b-th>
                                <b-th></b-th>
                                <b-th>
                                    <p class="labelP">TOTAL AMOUNT</p>
                                    <p class="valueP">{{ currency_icon }}{{ total }}</p>
                                    <p class="labelP" v-if="vat != 0">VAT Included</p>
                                </b-th>
                            </b-tr></b-tfoot>
                    </b-table-simple>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

export default {
    name: "GardenHelpQuoteDetails",
    components: {},
    props: ["quote_table_items", "contractor_name", "vat_number", "issue_date", "booking_date",
        "job_type", "quote_number", "customer_name", "quote_status", "subtotal", "vat", "total",
        "contractor_phone", "contractor_email", "currency_code", "currency_icon",
        "company_logo","company_reg_no", "contractor_address", 'isQuote', 'contractor_reg_number', 'quote_paid'],
    data() {
        return {
            client_name: "GARDENHELP",
            user_type: null,
            user_id: null,

            show_overlay: false,

            quote_table_fields: ['service', 'price'],
            isPaid: this.quote_paid
            ///////
        }
    },

    mounted() {

    },
    methods: {
    }
}

</script>


// WEBPACK FOOTER //
// src/projects/garden_help/quotes/QuoteDetails.vue